import React from 'react';

/**
 * The Snapcipe avocado glyph - vector mark from the brand system
 * (design_handoff_snapcipe_landing/brand/glyph-reversed.svg).
 * The pit is a knockout, not a colour: `pit` must match whatever sits
 * behind the mark (BRAND.md), which on this site is the page `#070A08`.
 */
const Glyph = ({ height = 38, ink = '#F4F7F4', pit = '#070A08', style }) => {
  const width = Math.round(height * (164 / 238));
  return (
    <svg
      viewBox="168 114 164 238"
      width={width}
      height={height}
      role="img"
      aria-label="Snapcipe AI"
      style={{ display: 'block', flex: 'none', ...style }}
    >
      <path
        d="M249.27 167.96C249.27 167.96 250.55 135.83 224.97 121.4"
        fill="none"
        stroke={ink}
        strokeWidth="15"
        strokeLinecap="round"
      />
      <path
        d="M240.52 153.9C240.52 153.9 232.51 135.01 205.64 135.38C187.91 135.63 176.72 149.23 175.92 165.89C175.92 165.89 186.2 156.74 197.01 160.42C211.93 165.51 231.76 165.03 240.52 153.9Z"
        fill={ink}
        stroke={ink}
        strokeWidth="7"
        strokeLinejoin="round"
      />
      <path
        d="M301.12 208.81C301.15 207.68 301.13 206.54 301.08 205.39C299.9 181.48 280.45 169.76 256.54 168.69C229.74 167.49 207.64 181.21 207.64 207.74C207.64 207.89 207.64 208.04 207.64 208.18C207.76 221.08 203.96 225.98 196.91 236.78C189.66 247.88 185.54 261.21 185.82 275.53C186.52 312.03 216.24 341.88 252.73 342.74C291.36 343.64 322.96 312.6 322.96 274.18C322.96 260.3 318.84 247.39 311.75 236.6C304.82 226.06 300.84 221.42 301.12 208.81Z"
        fill={ink}
      />
      <path
        d="M294.04 280.25C294.04 299.06 278.8 314.3 260 314.3C241.19 314.3 232.75 299.06 232.75 280.25C232.75 261.45 241.19 246.2 260 246.2C278.8 246.2 294.04 261.45 294.04 280.25Z"
        fill={pit}
      />
    </svg>
  );
};

export default Glyph;
